import PropTypes from 'prop-types';

import { Checkbox, handlePageClick, Pagination, Radio, usePaginatedItems } from '@utilities';

import { getOptionLabel } from '../../../../utilities/helpers';

import styles from './_index.module.scss';

const AttributeOptions = ({
  max,
  onAnswerChange,
  options,
  promptAnswerKey,
  promptAnswers = [],
  promptKey,
}) => {
  const answersPerPage = 8;
  const { data = [] } = options || {};
  const isMaxSelected = !max ? false : promptAnswers?.length >= max;

  const { currentItems, itemsPerPage, pageCount, setOffset } = usePaginatedItems({
    items: data,
    itemsPerPage: answersPerPage,
  });
  const onPageChange = (event) => {
    handlePageClick({ event, items: data, itemsPerPage: answersPerPage, setOffset });
  };

  const handleAnswerChange = (newAnswer) => {
    if (max === 1) {
      onAnswerChange(promptAnswerKey ? { [promptAnswerKey]: [newAnswer] } : [newAnswer]);
      return;
    }

    const isSelected = promptAnswers.some(({ id }) => id === newAnswer.id);

    const updatedAnswers = isSelected
      ? promptAnswers.filter(({ id }) => id !== newAnswer.id)
      : [...promptAnswers, newAnswer];

    onAnswerChange(promptAnswerKey ? { [promptAnswerKey]: updatedAnswers } : updatedAnswers);
  };

  return (
    <div className={styles['options']}>
      <ul className={styles['options-list']}>
        {currentItems?.map((option, index) => {
          const optionAnswers = promptAnswers
            ? promptAnswers.filter((answer) => answer.id === option.id)
            : [];

          const isChecked = optionAnswers?.length === 1;

          const optionAnswer = isChecked ? optionAnswers[0] : undefined;
          const value = optionAnswer || option;

          return (
            <li key={`option-${index}`}>
              {max === 1 ? (
                <Radio
                  isChecked={isChecked}
                  label={getOptionLabel({ option })}
                  name={promptKey}
                  onChange={() => handleAnswerChange(option)}
                  value={value}
                />
              ) : (
                <Checkbox
                  className={isChecked ? styles['is-selected'] : ''}
                  isChecked={isChecked}
                  isDisabled={isMaxSelected && !isChecked}
                  isInverseColor
                  label={getOptionLabel({ option })}
                  name={promptKey}
                  onChange={() => handleAnswerChange(option)}
                  value={value}
                />
              )}
            </li>
          );
        })}
      </ul>
      <Pagination
        onPageChange={onPageChange}
        pageCount={pageCount}
        show={data?.length > itemsPerPage}
      />
    </div>
  );
};

AttributeOptions.propTypes = {
  max: PropTypes.number,
  onAnswerChange: PropTypes.func,
  options: PropTypes.object,
  promptAnswerKey: PropTypes.string,
  promptAnswers: PropTypes.array,
  promptKey: PropTypes.string,
};

export default AttributeOptions;
